import PropTypes from 'prop-types'
import React, { Component } from "react"

import { connect } from "react-redux"
import { Link } from "react-router-dom"

import logo from "../../assets/images/VeeperLogo.svg"

// Redux Store
import { toggleRightSidebar } from "../../store/actions"

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: "Admin",
    }
    this.toggleMenu = this.toggleMenu.bind(this)
    this.toggleRightbar = this.toggleRightbar.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
  }

  componentDidMount() {
    if (localStorage.getItem("authUser")) {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        this.setState({ username: obj.displayName || obj.username || "Admin" })
      } catch (e) {
        // ignore parse errors
      }
    }
  }

  toggleMenu() {
    this.props.toggleMenuCallback()
  }

  toggleRightbar() {
    this.props.toggleRightSidebar()
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  getInitials = (name) => {
    return name
      .split(" ")
      .map(n => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2)
  }

  renderBrand = () => (
    <>
      <Link to="/" className="logo logo-dark">
        <span className="logo-sm">
          <div className="brand-icon-box">
            <img src={logo} alt="Veeper" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
          </div>
        </span>
        <span className="logo-lg">
          <div className="brand-icon-box">
            <img src={logo} alt="Veeper" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
          </div>
          <div className="brand-text-box">
            <span className="brand-name">Veeper</span>
            <span className="brand-subtitle">Admin Panel</span>
          </div>
        </span>
      </Link>

      <Link to="/" className="logo logo-light">
        <span className="logo-sm">
          <div className="brand-icon-box">
            <img src={logo} alt="Veeper" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
          </div>
        </span>
        <span className="logo-lg">
          <div className="brand-icon-box">
            <img src={logo} alt="Veeper" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
          </div>
          <div className="brand-text-box">
            <span className="brand-name">Veeper</span>
            <span className="brand-subtitle">Admin Panel</span>
          </div>
        </span>
      </Link>
    </>
  )

  render() {
    const { username } = this.state

    return (
      <header id="page-topbar" className="veeper-topbar">
        <div className="navbar-header">
          <div className="header-left">
            <div className="navbar-brand-box">
              {this.renderBrand()}
            </div>

            <button
              type="button"
              onClick={this.toggleMenu}
              className="btn header-item header-toggle-btn waves-effect"
              id="vertical-menu-btn"
              aria-label="Toggle navigation menu"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>

          <div className="header-spacer" aria-hidden="true" />

          <div className="header-right-group">
            <button
              type="button"
              onClick={this.toggleFullscreen}
              className="btn header-item header-action-btn waves-effect"
              data-toggle="fullscreen"
              title="Toggle fullscreen"
              aria-label="Toggle fullscreen"
            >
              <i className="bx bx-fullscreen" />
            </button>

            <div className="header-divider" />

            <div className="header-user-cluster">
              <div className="header-profile-section">
                <div className="header-avatar" aria-hidden="true">
                  {this.getInitials(username)}
                </div>
                <div className="header-profile-info">
                  <span className="header-profile-name">{username}</span>
                  <span className="header-profile-role">Administrator</span>
                </div>
              </div>

              <Link
                to="/logout"
                className="header-action-btn header-logout-btn"
                title="Sign out"
                aria-label="Sign out"
              >
                <i className="bx bx-power-off" />
              </Link>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

const mapStatetoProps = state => {
  const { layoutType } = state.Layout
  return { layoutType }
}

export default connect(mapStatetoProps, { toggleRightSidebar })(Header)

Header.propTypes = {
  toggleMenuCallback: PropTypes.func,
  toggleRightSidebar: PropTypes.func,
}
